var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const tagsDataProvider = context => {
    const basePath = `${context.apiUrl}/tags`;
    const basePathApi = `${context.apiUrl}/api-management/1.0/apis`;
    return {
        getManyReference: async ({ id }) => {
            const url = `${basePathApi}/${id}/tags`;
            const { json } = await context.fetchJson(url, {
                credentials: 'include',
            });
            return {
                data: json.map((_a) => {
                    var { uuid } = _a, item = __rest(_a, ["uuid"]);
                    return (Object.assign({ id: uuid }, item));
                }) || [],
                total: json.totalElements || 0,
            };
        },
        getList: async () => {
            const { json } = await context.fetchJson(basePath, {
                credentials: 'include',
            });
            return {
                data: json.map(item => (Object.assign({ id: item.name }, item))) || [],
                total: json.length,
            };
        },
        getMany: async () => {
            const { json } = await context.fetchJson(basePath, {
                credentials: 'include',
            });
            return {
                data: json.map(item => (Object.assign({ id: item.name }, item))) || [],
                total: json.length,
            };
        },
    };
};
//# sourceMappingURL=tags.js.map